import { ClubLogo } from '../components/ClubLogo';
import { Link } from 'react-router-dom';
import { roleLabel } from '@fsv/core';
import { readLastTenant, writeLastTenant } from '../auth/lastTenant';
import { Icon } from '../components/Icon';
import { useSession } from '../data/hooks';
import { tx } from '@fsv/data';
import { tenantPath } from '../lib/tenantRouting';
import './TenantPickerScreen.css';

/** /vereine: shown when someone belongs to several clubs and none is remembered (or from the switcher). */
export function TenantPickerScreen() {
  const { me } = useSession();
  const last = readLastTenant();
  return (
    <div className="page page--narrow picker">
      <header className="page__head">
        <h1>{tx.tenant.pickerTitle}</h1>
        <p className="muted">{tx.tenant.pickerIntro}</p>
      </header>
      {me.memberships.length === 0 ? (
        <NoTenantBody isPlatformManager={me.isPlatformManager} />
      ) : (
        <ul className="picker__list">
          {me.memberships.map((m) => (
            <li key={m.tenantId}>
              <Link to={tenantPath(m.slug)} className={`picker__card${m.slug === last ? ' is-last' : ''}`} onClick={() => writeLastTenant(m.slug)}>
                <ClubLogo
                  club={m}
                  size={44}
                  fallback={
                    <span className="picker__mark" aria-hidden="true">
                      <Icon name="club" size={26} />
                    </span>
                  }
                />
                <span className="picker__text">
                  <span className="picker__name">{m.name}</span>
                  <span className="picker__meta">
                    {roleLabel[m.role]} · <span className="mono">/v/{m.slug}</span>
                  </span>
                </span>
                <Icon name="forward" />
              </Link>
            </li>
          ))}
        </ul>
      )}
      {me.isPlatformManager && me.memberships.length > 0 && (
        <Link to="/plattform" className="btn picker__platform">
          <Icon name="platform" />
          {tx.tenant.toPlatform}
        </Link>
      )}
      <p className="field__hint">{tx.tenant.pickerRemember}</p>
    </div>
  );
}

function NoTenantBody({ isPlatformManager }: { isPlatformManager: boolean }) {
  return (
    <div className="notice" role="status">
      <Icon name="club" />
      <div className="stack">
        <p>
          <strong>{tx.tenant.noneTitle}</strong>
        </p>
        <p>{tx.tenant.noneBody}</p>
        {isPlatformManager && (
          <Link to="/plattform" className="btn">
            <Icon name="platform" />
            {tx.tenant.toPlatform}
          </Link>
        )}
      </div>
    </div>
  );
}

/** Signed in, but no active membership in an active club. */
export function NoTenantScreen() {
  const { me } = useSession();
  return (
    <div className="page page--narrow">
      <NoTenantBody isPlatformManager={me.isPlatformManager} />
    </div>
  );
}
